import type { ClassValue } from 'clsx';

import type { DateTimeSerializable } from '@vs-shop/schemas/DateTimeSerializable';
import { clsxm } from '@vs-shop/utils';
import { CalendarDays, CircleDollarSign } from 'lucide-react';

import { getDefaultCurrency } from '../../../config/currency';

import { IntlDate, IntlMoney } from '../../server/intl/Intl';

type Props = {
  active?: boolean;
  payload?: { value: number; payload: { date: string } }[];
  className?: ClassValue;
};

export default function ChartTooltip({ active, payload, className }: Props) {
  const currency = getDefaultCurrency();

  if (!active || !payload?.length) return null;

  const item = payload[0];
  if (!item) return null;

  const dateObj = {
    _tag: 'DateTime',
    value: item.payload.date,
  } satisfies DateTimeSerializable;

  return (
    <div
      className={clsxm(
        'rounded-lg border border-foreground/10 bg-background px-4 py-2.5 shadow-xl',
        className
      )}
    >
      <div className="flex items-center gap-3">
        <CalendarDays className="size-5 text-foreground-muted" />
        <IntlDate value={dateObj} />
      </div>
      <div className="flex items-center gap-3 text-lg font-semibold">
        <CircleDollarSign className="size-5 text-success" />
        <IntlMoney value={{ amount: item.value, currency }} />
      </div>
    </div>
  );
}
